import { render, staticRenderFns } from "./upload-image.vue?vue&type=template&id=2ade1dd6&scoped=true&"
import script from "./upload-image.vue?vue&type=script&lang=js&"
export * from "./upload-image.vue?vue&type=script&lang=js&"
import style0 from "./upload-image.vue?vue&type=style&index=0&id=2ade1dd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ade1dd6",
  null
  
)

export default component.exports